import React from "react";
import "../../Styles/NavBar/NavBar.css";
function NavBar({
  handleTheme,
  dark,
  resume,
  first_name,
  last_name,
  logo,
  handleRobotText,
}) {
  const handleActive = (e) => {
    let current = "";
    const sections = document.querySelectorAll("section");
    const navLinks = document.querySelectorAll("nav .menuContainer a");
    const arrows = document.querySelectorAll(".App svg");
    arrows.forEach((svg) => svg.classList.add("none"));
    sections.forEach((section) => {
      const top = section.getBoundingClientRect().top;
      if (top >= 0 && top <= window.innerHeight / 3) {
        current = section.getAttribute("id");
      }
    });
    if (current === "home") {
      arrows.forEach((svg) => svg.classList.remove("none"));
    }
    current &&
      navLinks.forEach((link) => {
        link.classList.remove("active");
        link.classList.contains(current) && link.classList.add("active");
      });
  };
  React.useEffect(() => {
    const mainPage = document.querySelector(".mainPage");
    mainPage.addEventListener("scroll", handleActive);

    return () => {
      mainPage.removeEventListener("scroll", handleActive);
    };
  }, []);

  return (
    <header className="navBar flexBox">
      <a href="#home" className="logoContainer flexBox">
        <img
          src={logo || process.env.PUBLIC_URL + "/images/Logo.png"}
          alt="Logo"
        />
        <h1>
          <span>{first_name || "Darshan"} </span> {last_name || "Naik"}
        </h1>
      </a>
      <div className="menuContainer flexBox">
        <a href="#home" className="home active">
          Home
        </a>
        <a href="#about" className="about">
          About
        </a>
        <a href="#projects" className="projects">
          Projects
        </a>
        {/* <a href="#resume" className="resume">Resume</a> */}
        <a href="#contacts" className="contacts">
          Contact
        </a>
      </div>
      <div className="links flexBox">
        <a
          href={resume}
          download={`${first_name} ${last_name}`}
          target="_blank"
          rel="noopener noreferrer"
          className="download"
          onMouseEnter={() => handleRobotText("Need a CV copy...?")}
        >
          Download CV
        </a>
        {/* <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.linkedin.com/in/darshannaik1995/"
            className="social flexBox"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/linkedin.png"}
              alt="Link"
            />
            LinkedIn
          </a> */}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://github.com/Darshan-Naik"
          className="social flexBox"
          onMouseEnter={() => handleRobotText("Visit his Github profile")}
        >
          <img
            src={process.env.PUBLIC_URL + "/images/git_icon.png"}
            alt="Link"
          />
          Github
        </a>
        <div
          className="theme"
          onClick={handleTheme}
          onMouseEnter={() => handleRobotText("You can change the Theme...")}
        >
          <img
            src={`${process.env.PUBLIC_URL} ${
              dark ? "/images/light.png" : "/images/dark.png"
            }`}
            alt="theme"
          />
        </div>
      </div>
    </header>
  );
}

export default NavBar;
